import axios from "axios";
import Vue from "vue";
import { URL_BASE } from "@/helper/constants.js";

export default () => {
  const instance = axios.create({
    baseURL: URL_BASE // BASEURL
  });
  let JWT = window.localStorage.getItem("JWT_TOKEN");
  if (JWT) {
    instance.defaults.headers.common["Authorization"] = JWT;
  }
  //   instance.defaults.headers.common['Authorization'] = '';
  // instance.defaults.headers.common['Access-Control-Allow-Origin'] = '*'
  instance.interceptors.response.use(
    function(response) {
      // Do something with response data
      return response;
    },
    function(error) {
      // Do something with response error
      if (error.response.status == 403) {
        // Error: 403
        console.log("Error 403 :");
      } else if (error.response.status == 401) {
        // Error: 401
        console.log("Error 401 :");
      } else {
        return Promise.reject(error);
      }
    }
  );
  return instance;
};



// WEBPACK FOOTER //
// ./src/services/Api.js